import $ from "jquery";
import CONFIG from "@bd-core/config";
import GameLogic from "@bd-core/game-logic";
import { getCurrentPageId } from "@bd-stores/user-progress";
import { subscribe } from "@bd-stores/store";
import { getAllRoomStatus } from "@bd-stores/game-progress";

export default class Navigation {
    constructor() {
        this.elms = {
            navigation: ".navigation",
            navigationTitle: ".navigation__title",
            navigationSubtitle: ".navigation__subtitle",
            navigationBar: ".navigation__bar",
            navigationButtonLeft: ".navigation__button.is-left",
            navigationButtonRight: ".navigation__button.is-right",
            navigationPopup: ".navigation__popup",
            navigationHeader: ".js-nav-header",
            navigationButton: ".js-nav-button",
            navigationCloseButton: ".js-nav-close-button",
            navigationPopupTitle: ".navigation__popup-title",
            navigationPopupContent: ".navigation__popup-content",
        };
        this.orderedRooms = [];
        this.currentIndex = 0;
        this.unsubscribe = null;

        this.allRoomStatus = {};
    }

    init() {
        this.setupInfiniteSlider();
        this.setupStoreListener();
    }

    setupInfiniteSlider() {
        const rooms = CONFIG.game.rooms;
        const mainRoom = rooms.find((room) => room.type === "main-room");
        const otherRooms = rooms.filter(
            (room) => room.type !== "main-room" && room.type !== "ladder-room",
        );

        if (!mainRoom) {
            console.warn("No main-room found in CONFIG.game.rooms");
            return;
        }

        // Create the infinite slider order
        const orderedRooms = this.createInfiniteSliderOrder(
            otherRooms,
            mainRoom,
        );

        // Set up navigation logic
        this.orderedRooms = orderedRooms;
        this.currentIndex = this.findCurrentPageIndex();

        this.renderNavigation();
        this.bindEvents();
        this.bindPageChangeListener();
    }

    createInfiniteSliderOrder(otherRooms, mainRoom) {
        const orderedRooms = [];

        // Add main room first
        orderedRooms.push(mainRoom);

        // Add other rooms in their original order
        for (let i = 0; i < otherRooms.length; i++) {
            if (otherRooms[i]) {
                orderedRooms.push(otherRooms[i]);
            }
        }

        return orderedRooms;
    }

    findCurrentPageIndex() {
        const currentPageId = getCurrentPageId();

        if (!currentPageId) {
            // Fallback to main room if no current page
            const mainRoomIndex = this.orderedRooms.findIndex(
                (room) => room.type === "main-room",
            );
            return mainRoomIndex;
        }

        // Find the index of the current page in the ordered rooms
        const index = this.orderedRooms.findIndex(
            (room) => room.id.toString() === currentPageId.toString(),
        );

        // If current page not found, fallback to main room
        if (index === -1) {
            const mainRoomIndex = this.orderedRooms.findIndex(
                (room) => room.type === "main-room",
            );
            return mainRoomIndex;
        }

        return index;
    }

    bindEvents() {
        // Bind left navigation button
        $(this.elms.navigationButtonLeft).on("click", () =>
            this.navigateLeft(),
        );

        // Bind right navigation button
        $(this.elms.navigationButtonRight).on("click", () =>
            this.navigateRight(),
        );

        // Bind navigation header click
        $(this.elms.navigationButton).on("click", () => this.openPopup());

        // Bind close popup button click
        $(this.elms.navigationCloseButton).on("click", () => this.closePopup());

        // Bind navigation items click
        this.bindNavigationItems();
    }

    setupStoreListener() {
        // Listen for store changes to update navigation when page changes
        this.unsubscribe = subscribe(() => {
            const newIndex = this.findCurrentPageIndex();
            if (newIndex !== this.currentIndex) {
                this.currentIndex = newIndex;
                this.updateNavigation();
            }
        });
    }

    bindPageChangeListener() {
        // Legacy method - now handled by store listener
        // Keep for backward compatibility if needed
    }

    bindNavigationItems() {
        // Use jQuery event delegation for navigation items
        $(".navigation__bar .track").on(
            "click",
            ".navigation__bar-item",
            (e) => {
                const $item = $(e.currentTarget);
                const roomId = $item.attr("data-room-id");
                if (roomId) {
                    this.goToRoomById(roomId);
                }
            },
        );
    }

    navigateLeft() {
        const leftRoomId = $(this.elms.navigationButtonLeft).attr(
            "data-room-id",
        );
        if (leftRoomId) {
            GameLogic.goToPage(leftRoomId);
        }
    }

    navigateRight() {
        const rightRoomId = $(this.elms.navigationButtonRight).attr(
            "data-room-id",
        );
        if (rightRoomId) {
            GameLogic.goToPage(rightRoomId);
        }
    }

    goToRoomById(roomId) {
        GameLogic.goToPage(roomId);
    }

    renderNavigation() {
        const $navigationBar = $(this.elms.navigationBar);
        if (!$navigationBar.length) return;

        const $track = $navigationBar.find(".track");
        if (!$track.length) return;

        // Clear existing navigation items
        $track.empty();

        // Create navigation items for each room
        this.orderedRooms.forEach((room, index) => {
            const $navItem = $("<div>")
                .addClass(
                    `navigation__bar-item ${
                        this.currentIndex === index ? "is-active" : ""
                    }`,
                )
                .attr("data-room-id", room.id.toString())
                .attr("data-room-index", index.toString());

            const $pointer = $("<div>").addClass(
                "navigation__bar-item--pointer",
            );
            const $checkmark = $("<div>").addClass(
                "navigation__bar-item--checkmark",
            );
            $navItem.append($pointer);
            $navItem.append($checkmark);

            $track.append($navItem);
        });

        let title = this.orderedRooms[this.currentIndex].title;
        let subtitle = this.orderedRooms[this.currentIndex].subtitle;
        let description = this.orderedRooms[this.currentIndex].description;

        if(this.orderedRooms[this.currentIndex].type === "main-room") {
            title = this.orderedRooms[this.currentIndex].room.title;
            subtitle = this.orderedRooms[this.currentIndex].room.subtitle;
            description = this.orderedRooms[this.currentIndex].room.description;
        }
        
        $(this.elms.navigationTitle).text(title);
        $(this.elms.navigationPopupTitle).text(title);
        $(this.elms.navigationPopupContent).html(description);

        if (subtitle === '') {
            $(this.elms.navigationSubtitle).text('Subtitle...').css('opacity', '0');
        } else {
            $(this.elms.navigationSubtitle).text(subtitle).css('opacity', '1');
        }

        // Center the active item
        this.centerActiveItem();

        this.updateNavigationButtons();
    }

    updateNavigation() {
        // Update active navigation item
        $('.navigation__bar-item').each((index, item) => {
            $(item).toggleClass('is-active', index === this.currentIndex);
        });
        $(this.elms.navigationPopup).toggleClass('is-completed', this.allRoomStatus[this.orderedRooms[this.currentIndex].id] === 'is-status-completed');

        // Center the active item by calculating transform offset
        this.centerActiveItem();

        let title = this.orderedRooms[this.currentIndex].title;
        let subtitle = this.orderedRooms[this.currentIndex].subtitle;
        let description = this.orderedRooms[this.currentIndex].description;

        if(this.orderedRooms[this.currentIndex].type === "main-room") {
            title = this.orderedRooms[this.currentIndex].room.title;
            subtitle = this.orderedRooms[this.currentIndex].room.subtitle;
            description = this.orderedRooms[this.currentIndex].room.description;
        }
        
        $(this.elms.navigationTitle).text(title);
        $(this.elms.navigationPopupTitle).text(title);
        $(this.elms.navigationPopupContent).html(description);

        if (subtitle === '') {
            $(this.elms.navigationSubtitle).text('Subtitle...').css('opacity', '0');
        } else {
            $(this.elms.navigationSubtitle).text(subtitle).css('opacity', '1');
        }

        // Update navigation buttons with new data attributes
        this.updateNavigationButtons();
        this.closePopup();
    }

    updateNavigationButtons() {
        if (this.orderedRooms.length === 0) return;

        // Calculate left and right room indices
        const leftIndex =
            (this.currentIndex - 1 + this.orderedRooms.length) %
            this.orderedRooms.length;
        const rightIndex = (this.currentIndex + 1) % this.orderedRooms.length;

        if (this.currentIndex === 0) {
            $(this.elms.navigationButtonLeft).addClass('is-hidden');
        } else {
            $(this.elms.navigationButtonLeft).removeClass('is-hidden');
            
            const leftRoom = this.orderedRooms[leftIndex];
            if (leftRoom) {
                $(this.elms.navigationButtonLeft).attr(
                    "data-room-id",
                    leftRoom.id.toString(),
                );
            }
        }

        if (this.currentIndex === this.orderedRooms.length - 1) {
            $(this.elms.navigationButtonRight).addClass('is-hidden');
        } else {
            $(this.elms.navigationButtonRight).removeClass('is-hidden');
            
            const rightRoom = this.orderedRooms[rightIndex];
            if (rightRoom) {
                $(this.elms.navigationButtonRight).attr(
                    "data-room-id",
                    rightRoom.id.toString(),
                );
            }
        }
    }

    centerActiveItem() {
        const $track = $(this.elms.navigationBar).find(".track");
        if (!$track.length || this.orderedRooms.length === 0) return;

        // Calculate the offset needed to center the active item
        const inactiveItemWidth = 8; // inactive item width
        const activeItemWidth = 32; // active item width
        const gap = 64; // gap between items

        // Calculate the total width with the active item expanded
        let totalWidth = 0;
        for (let i = 0; i < this.orderedRooms.length; i++) {
            if (i === this.currentIndex) {
                totalWidth += activeItemWidth; // active item is wider
            } else {
                totalWidth += inactiveItemWidth; // inactive items
            }
            if (i < this.orderedRooms.length - 1) {
                totalWidth += gap; // add gap between items
            }
        }

        // Calculate the position of the active item's center
        let activeItemCenterPosition = 0;
        for (let i = 0; i < this.currentIndex; i++) {
            activeItemCenterPosition += inactiveItemWidth + gap;
        }
        activeItemCenterPosition += activeItemWidth / 2; // center of active item

        // Calculate how much we need to shift to center the active item
        const centerOffset = totalWidth / 2;
        const transformOffset = centerOffset - activeItemCenterPosition;

        // Apply the transform
        $track.css(
            "transform",
            `translateX(calc(-50% + ${transformOffset}px))`,
        );
    }

    refreshActiveState() {
        // Refresh the active state based on current page
        this.currentIndex = this.findCurrentPageIndex();
        this.updateNavigation();
    }

    updateAllRoomStatus() {
        this.allRoomStatus = getAllRoomStatus();
        $('.navigation__bar-item').each((_, item) => {
            $(item).toggleClass('is-completed', this.allRoomStatus[$(item).attr('data-room-id')] === 'is-status-completed');

        const currentRoom = this.orderedRooms[this.currentIndex];
        if (
            currentRoom &&
            this.allRoomStatus[currentRoom.id] === 'is-status-completed'
        ) {
            $(this.elms.navigationPopup).addClass('is-completed');
        } else {
            $(this.elms.navigationPopup).removeClass('is-completed');
        }
        });
    }

    // Public method to refresh navigation from outside
    refresh() {
        this.refreshActiveState();
    }

    // Clean up method to remove store listener
    destroy() {
        if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
        }
    }

    openPopup() {
        $(this.elms.navigationPopup).addClass("is-open");
        $(this.elms.navigationHeader).addClass("is-hiding");
    }

    closePopup() {
        $(this.elms.navigationPopup).removeClass("is-open");
        $(this.elms.navigationHeader).removeClass("is-hiding");
    }
}
